package screens.static.settings

import common.ECssClasses
import core.enums.ELocalizationKeys
import core.extensions.toClassName
import core.ionic.EmptyProps
import core.ionic.IonRow
import core.localization.Localization
import csstype.AlignItems
import csstype.px
import emotion.react.css
import kotlinx.browser.document
import org.w3c.dom.HTMLDivElement
import react.FC
import react.dom.html.ReactHTML
import react.useEffect
import react.useRef

val CookieSettings = FC<EmptyProps> {

    val mDivRef = useRef<HTMLDivElement>(null)

    useEffect(mDivRef) {
        val script = document.createElement("script").asDynamic()
        script.id = "CookieDeclaration"
        script.src = "https://consent.cookiebot.com/93e16125-3081-4633-adb1-37ef325d3d4f/cd.js"
        script.async = true
        script.type = "text/javascript"
        mDivRef.current?.appendChild(script)

        cleanup {
            mDivRef.current?.innerHTML = ""
        }
    }

    IonRow {
        css {
            alignItems = AlignItems.Companion.center
            marginLeft = 16.px
            marginRight = 16.px
        }
        ReactHTML.span {
            css(ECssClasses.LIST_HEADER_FONT.toClassName()) {
                marginLeft = 0.px
            }
            +Localization.getLocalizationKey(ELocalizationKeys.SETTINGS_COOKIE_SETTING_TITLE.name)
        }
    }
    ReactHTML.div {
        css {
            marginLeft = 16.px
            marginRight = 16.px
        }
        id = "cookieDeclarationCustomId"
        ref = mDivRef
    }
}